import './ServiceRecentActivity.scss';

/* eslint-disable @typescript-eslint/no-shadow */
import { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import Header from '../../../../components/Header/Header';
import {
  useReadTQActivityLog,
} from '../../../../hooks/mutations/tqConnectMutations/service-requests';
import {
  useTQConnectActivityLogs,
} from '../../../../hooks/queries/tqConnectQueries/service-requests';
import { useAppNavigate } from '../../../../shared/hooks';
import { getReadableDateFormat } from '../../../../shared/utils';
import {
  ITQActivityLog,
  TQServiceRequestTypeValue,
} from '../../../../types/tqConnectTypes/service-requests';
import RecentActivityList from './RecentActivityList';

const ServiceRecentActivity = () => {
  const navigate = useAppNavigate();
  const { requestType } = useParams<{
    requestType: TQServiceRequestTypeValue;
  }>();
  const {
    data: activityLogsResult,
    isLoading: loading,
    hasNextPage: hasMore,
    fetchNextPage,
    isFetchingNextPage,
    // refetch,
    // isFetching,
    // error,
    // dataUpdatedAt: recentActivityLastRefreshedAt,
  } = useTQConnectActivityLogs();

  const { markActivityLogAsRead } = useReadTQActivityLog();

  const { groupedByDateList, total } = useMemo(() => {
    const list = activityLogsResult?.data ?? [];

    const groupedByDateList: Record<string, ITQActivityLog[]> = list.reduce(
      (acc: Record<string, ITQActivityLog[]>, activity: ITQActivityLog) => {
        const date = getReadableDateFormat(activity.createdAt);
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(activity);
        return acc;
      },
      {},
    );

    return {
      groupedByDateList,
      total: activityLogsResult?.total ?? 0,
    };
  }, [activityLogsResult?.data, activityLogsResult?.total]);

  // const refreshRecentActivity = async () => {
  //   try {
  //     const resp = await refetch();
  //     if (resp.status === 'success') {
  //       message.success('Done! Your recent activity is now up to date.');
  //     }
  //   } catch (error) {
  //     showAppError(error);
  //   }
  // };

  const loadMore = () => {
    if (hasMore && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const handleBack = () => {
    navigate.goBack();
  };

  return (
    <div className="recent-activity">
      <Header
        title={`Recent Activity ${activityLogsResult?.total && activityLogsResult?.total > 0 ? `(${activityLogsResult?.total})` : ''}`}
        handleBack={handleBack}
        backType="arrow"
      />

      <RecentActivityList
        requestType={requestType as TQServiceRequestTypeValue}
        groupedByDateList={groupedByDateList}
        total={total}
        loading={loading}
        isFetchingNextPage={isFetchingNextPage}
        hasMore={hasMore}
        onLoadMore={loadMore}
        onMarkAsRead={markActivityLogAsRead}
      />
    </div>
  );
};

export default ServiceRecentActivity;
